module.exports = __webpack_public_path__ + "static/img/5-4.e4b0e832.jpg";